export function search(payload: { query: string; includeExpired?: boolean }): Promise<any> {
  return this.API.request('search', payload)
}
